// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_ZlM","cls2":"Accordion-cls2_eKJ Accordion-cls1_ZlM"};